<template>
  <div>
    <!-- Titulo -->
    <div class="d-flex align-items-center" style="margin-top: -20px">
      <h6 style="margin: 0px !important">
        Nueva solicitud de Booking planificado
      </h6>

      <i v-if="dataTableAux.length"
        class="fas fa-info-circle ml-2 girarObjeto pulsoAmarillo"
        :title="`Listado de las planificaciones semanales disponibles, pertenecientes a la semana actual y las 4 siguientes realizadas por tu empresa para el año ${dataTableAux[0].data_complementaria.year.name}. Para continuar, selecciona la planificación en la cual deseas generar un nuevo Booking.`"
        style="cursor: help"
      ></i>

    </div>

    <!-- cuerpo (Formulario) -->
    <data-table
      v-if="acciones"
      :headers="headers"
      :data="dataTableAux"
      :acciones="acciones"
      :max="10"
      paginacion
      buscar
      idtabla="booking_planificado"
      :seleccionar="obtenerFilaSeleccionada"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getBookingsPlanificados } from '../../../constants/lineas';
import DataTable from "../DataTable";

export default {

  data() {
    return {

      dataTableAux: [],

      headers: [
        "Semana",
        "POD",
        "Equipo",
        "Cantidad planificada",
        "Cantidad disponible",
        "Acciones",
      ],

      acciones: [],
    };
  },

  components: { DataTable },

  methods: {

    ...mapActions('lineas',['actionSetFormularioSolicitudNoPlanificada','actionSetEstadoSolicitudReservaPlanificada', 'actionSetIsBookingPlanned']),

    generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      me.dataTableAux.map((_, index) => {
        me.acciones.push([
          {
            icon: "far fa-paper-plane",
            title: "Nuevo Booking",
            id: index,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {

      let id = fila.id;

      const data = this.dataTableAux[id].data_complementaria;

      let formulario = {
        anioModel: { id: data.year.id , name: data.year.name.toString() },
        cantidadContenedoresModel:  this.dataTableAux[id].data[3],
        cantidadDisponibleContenedores: data.available_qty,
        contenedoresModel : data.container,
        empresa : data.client,
        puertosModel : data.port,
        semanaModel : { id: data.week.id, name: data.week.name.toString()}

      }

      
      this.actionSetEstadoSolicitudReservaPlanificada(true);
      this.actionSetFormularioSolicitudNoPlanificada(formulario);
      this.actionSetIsBookingPlanned(1);
      
    },

    async obtenerPlanificaciones(){
      const sql = await getBookingsPlanificados();
      this.dataTableAux = sql;

      this.generarBotonesAcciones();
    }

  },

  created() {
    this.obtenerPlanificaciones();
  },

  watch: {
    dataTableAux: function (_new) {
      if (_new) {
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
